import { withInstall } from "../utils/index.mjs";
import _Popup from "./Popup.mjs";
const Popup = withInstall(_Popup);
var stdin_default = Popup;
import { popupProps } from "./Popup.mjs";
export {
  Popup,
  stdin_default as default,
  popupProps
};
